<template>
  <div class="member">
    <ul class="member__list">
      <li v-for="member in renderMembers" :key="member.id" class="member__item">
        <div class="member__img">
          <img :src="member.image" alt="" />
        </div>
        <div class="member__body">
          <div class="member__body-item -name">
            <div class="member__body-itemin -jp">{{ member.Name }}</div>
            <div class="member__body-itemin -en">{{ member.Alphabet }}</div>
          </div>
          <div class="member__body-item -job">{{ member.job }}</div>
          <div class="member__body-item -hobby">{{ member.hobby }}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  computed: {
    members() {
      return this.$store.state.members;
    },
    rawMember() {
      let member = this.sortMember(this.members);

      const one_item = this.searchCat(member, this.$store.state.cat);
      const two_item = this.searchTag(member, this.$store.state.selectTag);

      member = this.allFilter(member, one_item, two_item);

      return member;
    },
    renderMembers() {
      let member = this.rawMember;

      const winWidth = window.innerWidth;
      if (winWidth > 1278) {
        if (member.length == 2 || (member.length - 2) % 4 == 0) {
          for (var a = 0; a < 2; a++) {
            member.push({
              Name: "",
              image: "",
              job: "",
              hobby: "",
              Alphabet: ""
            });
          }
        } else if (member.length == 3 || (member.length - 3) % 4 == 0) {
          member.push({
            Name: "",
            image: "",
            job: "",
            hobby: "",
            Alphabet: ""
          });
        }
      } else if (winWidth < 1278 && winWidth > 980) {
        if (member.length % 3 > 0) {
          for (var i = 0; i < member.length % 3; i++) {
            member.push({
              Name: "",
              image: "",
              job: "",
              hobby: "",
              Alphabet: ""
            });
          }
        }
      }

      // 768で2子　980で3子　1279で4子

      return member;
    },
    sort() {
      return this.$store.state.sort;
    }
  },
  methods: {
    searchCat(members, cat) {
      if (cat == "" || cat == "All") {
        return members;
      }
      return members.filter(member => {
        return member.business == cat;
      });
    },
    sortMember(members) {
      members.sort((a, b) => {
        if (a.Alphabet > b.Alphabet) {
          return this.sort ? 1 : -1;
        }
        if (a.Alphabet < b.Alphabet) {
          return this.sort ? -1 : 1;
        }
        return 0;
      });
      return members;
    },
    searchTag(members, tag) {
      if (tag == "") {
        return members;
      }
      return members.filter(member => {
        return member.job == tag;
      });
    },
    allFilter(members, cat, tag) {
      const all = [...cat, ...tag];
      return members.filter(member => {
        return cat.includes(member) && tag.includes(member);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.member {
  margin-top: 29px;

  &__list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  &__item {
    width: calc(100% / 4 - 26px * 3 / 4);
    display: flex;

    &:nth-child(n + 5) {
      margin-top: 60px;
    }

    @include max(1279) {
      width: calc(100% / 3 - 26px * 2 / 3);

      &:nth-child(n + 4) {
        margin-top: 60px;
      }
    }

    @include max(980) {
      width: calc(100% / 2 - 26px * 1 / 2);

      &:nth-child(n + 3) {
        margin-top: 30px;
      }
    }

    @include max(768) {
      width: calc(100% / 2 - 20px * 1 / 2);

      &:nth-child(n + 3) {
        margin-top: 20px;
      }
    }
  }

  &__img {
    // width: 120px;
    // height: 120px;
    width: 46%;
    min-width: 46%;
    max-width: 46%;

    border-radius: 14px;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  &__body {
    margin-left: 20px;
    padding-top: 15px;
    // width: 54%;

    @include max(768) {
      padding-top: 5px;
    }

    &-itemin {
      &.-jp {
        font-size: 14px;

        @include min(1281) {
          font-size: vw(12, 1281);
        }

        @include max(768) {
          font-size: 12px;
        }
      }

      &.-en {
        font-size: 10px;
        color: #8c8c8c;

        @include min(1281) {
          font-size: vw(10, 1281);
        }
      }
    }

    &-item {
      &.-job,
      &.-hobby {
        margin-top: 10px;
        font-size: 12px;
        color: #8c8c8c;

        @include max(768) {
          margin-top: 5px;
          font-size: 10px;
        }

        @include min(1281) {
          font-size: vw(12, 1281);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TOP/contents/Members/_index.vue